/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAPIHandler from "../../../../hook/use-api-handler";
import { extractOnlyNumbers, parseOnlyNumericValue, removeAllSpaces, removeMultipleSpace, removeUnderScrSpaceBet, removeUnderScrSpCharSpaceBet, safeToString, sliceText } from "../../../../utils/common";
import { logger } from "../../../../utils/logger";
import { ORGANIZATION_INITIAL_STATE } from "./add-organization-constant";
import { OrgSchema } from "./add-organization-validation";

const useAddOrganizationService = ({ openSnackbar }) => {
    const navigate = useNavigate()
    const { fetchData } = useAPIHandler();
    const [orgData, setOrgData] = useState(ORGANIZATION_INITIAL_STATE);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [allState, setAllState] = useState([]);

    const fileInputRef = useRef(null);
    const [previewURL, setPreviewURL] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [orgProfile, setOrgProfile] = useState(ORGANIZATION_INITIAL_STATE);
    
   

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };


    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword((prevState) => !prevState);
    };

    const fetchAllState = async () => {

        try {
            const response = await fetchData({
                url: '/common/state',
                method: "GET",
            })
            if (response?.status === 'success' && Array.isArray(response?.data)) {
                const mappedData = response?.data?.map((item) => ({
                    id: item?.state_id,
                    name: item?.state_name
                }))
                setAllState(mappedData)
            }
        } catch (error) {
            logger.log(error,"LLL")
        }

    }


    const handleSubmit = async () => {
        const {
            org_name,
            landline,
            phone,
            email,
            domain_name,
            tan_no,
            pan,
            industry_type,
            registration_type,
            date_of_org,
            payment_type,
            address,
            locality,
            city,
            state,
            pincode,
            landmark,
            first_name,
            last_name,
            password,
            confirm_password,
        } = orgData;
    
        const { error } = OrgSchema.validate(
            {
                org_name,
                landline,
                phone,
                email,
                domain_name,
                tan_no,
                pan,
                industry_type,
                registration_type,
                date_of_org,
                payment_type,
                address,
                locality,
                city,
                state,
                pincode,
                landmark,
                first_name,
                last_name,
                password,
                confirm_password
            },
            {
                abortEarly: false,
            }
        );
    
        if (error && error?.details?.length > 0) {
            const validationErrors = error.details.reduce((acc, err) => {
                const pathname = err.path.join(".");
                acc[pathname] = err.message;
                return acc;
            }, {});
            setErrors(validationErrors);
            return; 
        }
    
        if (password !== confirm_password) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                confirm_password: "Passwords do not match",
            }));
            openSnackbar({
                message: "Passwords do not match!",
                color: "danger",
            });
            return;
        }
    
        delete orgData.confirm_password;
        delete orgData.wages_type;
        delete orgData.previewURL
    
        try {
            const data = new FormData();
    
            for (const key in orgData) {
                data.append(key, orgData[key]);
            }

            if (selectedFile) {
                data.append("logo", selectedFile);
              }
    
            const url = "organization/admin/createOrganization";
            const payload = {
                url: url,
                method: "POST",
                data: data,
            };
    
            const response = await fetchData(payload);
            if (response.status === "success") {
                setOrgData(ORGANIZATION_INITIAL_STATE);
                openSnackbar({ message: "Organization created successfully!" });
                navigate("/admin/organization-list");
            }
        } catch (error) {
            logger.log(error);
    
            if (error?.type === "JoiValidationError") {
                const errorsAll = {};
                error?.errors?.reduce((acc, curr) => {
                    const { field, message } = curr;
                    errorsAll[field] = message;
                    return acc;
                });
                openSnackbar({
                    message:
                        Object.keys(errorsAll).length > 0
                            ? "Validation Error!"
                            : "Something went wrong!",
                    color: "danger",
                });
                setErrors(errorsAll);
            } else if (error?.type === "GeneralError") {
                const backendMessage =
                    typeof error.message === "string"
                        ? error.message
                        : "An unexpected error occurred.";
    
                openSnackbar({
                    message: backendMessage,
                    color: "danger",
                });
            }
        }
    };
    


    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = OrgSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }

    const handleChange = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }

        if (name === "org_name") {
            value = sliceText(removeMultipleSpace(safeToString(value), 150))
        }
        if (name === "domain_name") {
            value = sliceText(safeToString(removeAllSpaces(safeToString(value))), 150)
        }

        if (name === "phone") {
            value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 10)
        }

        if (name === "landline") {
            value = sliceText(removeAllSpaces(extractOnlyNumbers(value)), 11)
        }

        if (name === "email") {
            value = sliceText(removeUnderScrSpaceBet(value.toLowerCase()), 150);
        }

        if (name === "address") {
            value = sliceText(removeMultipleSpace(safeToString(value)), 150);
        }


        if (name === "pan") {
            value = sliceText(removeUnderScrSpCharSpaceBet(value), 10);
        }

        if (name === "tan_no") {
            value = sliceText(removeUnderScrSpCharSpaceBet(value), 10);
        }

        if (name === "city") {
            value = sliceText(removeMultipleSpace(safeToString(value)), 100)
        }

        if (name === "pincode") {
            value = sliceText(parseOnlyNumericValue(safeToString(value)), 6);
        }

        if (name === "landmark") {
            value = sliceText(removeMultipleSpace(safeToString(value)), 100);
        }

        if (name === "locality") {
            value = sliceText(removeMultipleSpace(safeToString(value)), 150);
        }

        if (name === "first_name") {
            value = sliceText(value, 150);
        }

        if (name === "last_name") {
            value = sliceText(value, 150);
        }

        setOrgData((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = OrgSchema.extract(name);
        const { error } = fieldSchema.validate(value);
        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }

    }

    // eslint-disable-next-line
    useEffect(() => {
        fetchAllState();
      },[])

    return {
        handleSubmit,
        handleChange,
        errors,
        orgData,
        handleBlurFn,
        togglePasswordVisibility,
        showPassword,
        allState,
        showConfirmPassword,
        toggleConfirmPasswordVisibility,

        fileInputRef,
        previewURL,
        setSelectedFile,
        setPreviewURL,
        setOrgProfile
    }
}

export default useAddOrganizationService